import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { registryApi, routerApi } from './services/registry';

export const store = configureStore({
  reducer: {
    [registryApi.reducerPath]: registryApi.reducer,
    [routerApi.reducerPath]: routerApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      registryApi.middleware,
      routerApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);

export default store;
